"use strict";

var _slicedToArray = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractSetDataType = void 0;

var ethUtil = require("ethereumjs-util");

var _ = require("lodash");

var configured_bignumber_1 = require("../../../configured_bignumber");

var set_1 = require("../../calldata/blocks/set");

var constants_1 = require("../../utils/constants");

var data_type_1 = require("../data_type");

var pointer_1 = require("./pointer");

var AbstractSetDataType = /*#__PURE__*/function (_data_type_1$DataType) {
  _inherits(AbstractSetDataType, _data_type_1$DataType);

  var _super = _createSuper(AbstractSetDataType);

  function AbstractSetDataType(dataItem, factory) {
    var _this;

    var isArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var arrayLength = arguments.length > 3 ? arguments[3] : undefined;
    var arrayElementType = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, AbstractSetDataType);

    _this = _super.call(this, dataItem, factory);
    _this._memberIndexByName = {};
    _this._members = [];
    _this._isArray = isArray;
    _this._arrayLength = arrayLength;
    _this._arrayElementType = arrayElementType;

    if (isArray && arrayLength !== undefined) {
      var _this$_createMembersW = _this._createMembersWithLength(dataItem, arrayLength);

      var _this$_createMembersW2 = _slicedToArray(_this$_createMembersW, 2);

      _this._members = _this$_createMembersW2[0];
      _this._memberIndexByName = _this$_createMembersW2[1];
    } else if (!isArray) {
      var _this$_createMembersW3 = _this._createMembersWithKeys(dataItem);

      var _this$_createMembersW4 = _slicedToArray(_this$_createMembersW3, 2);

      _this._members = _this$_createMembersW4[0];
      _this._memberIndexByName = _this$_createMembersW4[1];
    }

    return _this;
  }

  _createClass(AbstractSetDataType, [{
    key: "generateCalldataBlock",
    value: function generateCalldataBlock(value, parentBlock) {
      var block = Array.isArray(value) ? this._generateCalldataBlockFromArray(value, parentBlock) : this._generateCalldataBlockFromObject(value, parentBlock);
      return block;
    }
  }, {
    key: "generateValue",
    value: function generateValue(calldata, rules) {
      var _this2 = this;

      var members = this._members; // Case 1: This is an array of undefined length, which means that `this._members` was not
      //         populated in the constructor. So we must construct the set of members now.

      if (this._isArray && this._arrayLength === undefined) {
        var arrayLengthBuf = calldata.popWord();
        var arrayLengthHex = ethUtil.bufferToHex(arrayLengthBuf);
        var arrayLength = new configured_bignumber_1.BigNumber(arrayLengthHex, constants_1.constants.HEX_BASE);

        var _this$_createMembersW5 = this._createMembersWithLength(this.getDataItem(), arrayLength.toNumber());

        var _this$_createMembersW6 = _slicedToArray(_this$_createMembersW5, 1);

        members = _this$_createMembersW6[0];
      } // Create a new scope in the calldata, before descending into the members of this set.


      calldata.startScope();
      var value;

      if (rules.shouldConvertStructsToObjects && !this._isArray) {
        // Construct an object with values for each member of the set.
        value = {};

        _.each(this._memberIndexByName, function (idx, key) {
          var member = _this2._members[idx];
          var memberValue = member.generateValue(calldata, rules);
          value[key] = memberValue;
        });
      } else {
        // Construct an array with values for each member of the set.
        value = [];

        _.each(members, function (member, idx) {
          var memberValue = member.generateValue(calldata, rules);
          value.push(memberValue);
        });
      } // Close this scope and return tetheh value.


      calldata.endScope();
      return value;
    }
  }, {
    key: "isStatic",
    value: function isStatic() {
      // An array with an undefined length is never static.
      if (this._isArray && this._arrayLength === undefined) {
        return false;
      } // If any member of the set is a pointer then the set is not static.


      var dependentMember = _.find(this._members, function (member) {
        return member instanceof pointer_1.AbstractPointerDataType;
      });

      var isStatic = dependentMember === undefined;
      return isStatic;
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue(rules) {
      var _this3 = this;

      var defaultValue;

      if (this._isArray && this._arrayLength === undefined) {
        defaultValue = [];
      } else if (rules !== undefined && rules.shouldConvertStructsToObjects && !this._isArray) {
        defaultValue = {};

        _.each(this._memberIndexByName, function (idx, key) {
          var member = _this3._members[idx];
          var memberValue = member.getDefaultValue();
          defaultValue[key] = memberValue;
        });
      } else {
        defaultValue = [];

        _.each(this._members, function (member, idx) {
          var memberValue = member.getDefaultValue();
          defaultValue.push(memberValue);
        });
      }

      return defaultValue;
    }
  }, {
    key: "_generateCalldataBlockFromArray",
    value: function _generateCalldataBlockFromArray(value, parentBlock) {
      // Sanity check: if the set has a defined length then `value` must have the same length.
      if (this._arrayLength !== undefined && value.length !== this._arrayLength) {
        throw new Error("Expected array of ".concat(JSON.stringify(this._arrayLength), " elements, but got array of length ").concat(JSON.stringify(value.length)));
      } // Create a new calldata block for this set.


      var parentName = parentBlock === undefined ? '' : parentBlock.getName();
      var block = new set_1.SetCalldataBlock(this.getDataItem().name, this.getSignature(), parentName); // If this set has an undefined length then set its header to be the number of elements.

      var members = this._members;

      if (this._isArray && this._arrayLength === undefined) {
        var _this$_createMembersW7 = this._createMembersWithLength(this.getDataItem(), value.length);

        var _this$_createMembersW8 = _slicedToArray(_this$_createMembersW7, 1);

        members = _this$_createMembersW8[0];
        var lenBuf = ethUtil.setLengthLeft(ethUtil.toBuffer("0x".concat(value.length.toString(constants_1.constants.HEX_BASE))), constants_1.constants.EVM_WORD_WIDTH_IN_BYTES);
        block.setHeader(lenBuf);
      } // Create blocks for members of set.


      var memberCalldataBlocks = [];

      _.each(members, function (member, idx) {
        var memberBlock = member.generateCalldataBlock(value[idx], block);
        memberCalldataBlocks.push(memberBlock);
      });

      block.setMembers(memberCalldataBlocks);
      return block;
    }
  }, {
    key: "_generateCalldataBlockFromObject",
    value: function _generateCalldataBlockFromObject(obj, parentBlock) {
      var _this4 = this;

      // Create a new calldata block for this set.
      var parentName = parentBlock === undefined ? '' : parentBlock.getName();
      var block = new set_1.SetCalldataBlock(this.getDataItem().name, this.getSignature(), parentName); // Create blocks for members of set.

      var memberCalldataBlocks = [];

      _.forEach(this._memberIndexByName, function (memberIndex, memberName) {
        if (!(memberName in obj)) {
          throw new Error("Could not assign tuple to object: missing key '".concat(memberName, "' in object ").concat(JSON.stringify(obj)));
        }

        var memberValue = obj[memberName];

        var memberBlock = _this4._members[memberIndex].generateCalldataBlock(memberValue, block);

        memberCalldataBlocks.push(memberBlock);
      }); // Associate member blocks with Set block.


      block.setMembers(memberCalldataBlocks);
      return block;
    }
  }, {
    key: "_computeSignatureOfMembers",
    value: function _computeSignatureOfMembers(isDetailed) {
      var _this5 = this;

      // Compute signature of members
      var signature = "(";

      _.each(this._members, function (member, i) {
        signature += member.getSignature(isDetailed);

        if (i < _this5._members.length - 1) {
          signature += ',';
        }
      });

      signature += ')';
      return signature;
    }
  }, {
    key: "_createMembersWithKeys",
    value: function _createMembersWithKeys(dataItem) {
      var _this6 = this;

      // Sanity check
      if (dataItem.components === undefined) {
        throw new Error("Tried to create a set using key/value pairs, but no components were defined by the input DataItem '".concat(dataItem.name, "'."));
      } // Create one member for each component of `dataItem`


      var members = [];
      var memberIndexByName = {};
      var memberNames = [];

      _.each(dataItem.components, function (memberItem) {
        // If a component with `name` already exists then
        // rename to `name_nameIdx` to avoid naming conflicts.
        var memberName = memberItem.name;
        var nameIdx = 0;

        while (_.includes(memberNames, memberName) || _.isEmpty(memberName)) {
          nameIdx++;
          memberName = "".concat(memberItem.name, "_").concat(nameIdx);
        }

        memberNames.push(memberName);
        var childDataItem = {
          type: memberItem.type,
          name: "".concat(dataItem.name, ".").concat(memberName)
        };
        var components = memberItem.components;

        if (components !== undefined) {
          childDataItem.components = components;
        }

        var child = _this6.getFactory().create(childDataItem, _this6);

        memberIndexByName[memberName] = members.length;
        members.push(child);
      });

      return [members, memberIndexByName];
    }
  }, {
    key: "_createMembersWithLength",
    value: function _createMembersWithLength(dataItem, length) {
      var _this7 = this;

      // Create `length` members, deriving the type from `dataItem`
      var members = [];
      var memberIndexByName = {};

      var range = _.range(length);

      _.each(range, function (idx) {
        var memberDataItem = {
          type: _this7._arrayElementType === undefined ? '' : _this7._arrayElementType,
          name: "".concat(dataItem.name, "[").concat(idx.toString(constants_1.constants.DEC_BASE), "]")
        };
        var components = dataItem.components;

        if (components !== undefined) {
          memberDataItem.components = components;
        }

        var memberType = _this7.getFactory().create(memberDataItem, _this7);

        memberIndexByName[idx.toString(constants_1.constants.DEC_BASE)] = members.length;
        members.push(memberType);
      });

      return [members, memberIndexByName];
    }
  }]);

  return AbstractSetDataType;
}(data_type_1.DataType);

exports.AbstractSetDataType = AbstractSetDataType;